import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { FormattedMessage } from 'react-intl';

import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import * as Render from './../../../lib/render';
import * as Validator from './../../../lib/validate';

import Box from "@material-ui/core/Box";

import {QrReader} from 'react-qr-reader';
import readQRcss from "./readQR.module.css";

const styles = theme => ({
  root: {
    display: 'flex',
  },
  container: {
    width: '100%',
    padding: '0 12px 0 12px',
  },
  container2: {
    width: '100%',
    padding: '0 12px 0 0',
  },
  container3: {
    padding: '0 0 0 12px',
  },
  header: {
    backgroundColor: '#5dabdb',
    color: '#ffffff',
    textAlign: 'center',
    padding: '20px'
  },
  rows: {
    width: '100%',
    padding: '20px 12px 20px 12px',
    border: "1px solid rgba(224, 224, 224, 1)",
    backgroundColor: '#deebf7',
  },
  fs80:{
    fontSize: 25,
    textAlign: 'center',
  },
  explanation:{
    fontSize: 25,
    textAlign: 'center',
    whiteSpace: "pre-line",
    padding: '20px 10px 10px 10px'
  },
  text: {
    fontSize: '10pt',
    padding: '36px 0 20px 0',
  },
  text2:{
    fontSize: 20,
    textAlign: 'center',
  },
  text3: {
    textAlign: 'left',
    padding: '0px 0px 20px 0px'
  },
  title: {
    minWidth: '100px',
    maxWidth: '140px',
  },
  fontBlue: {
    color: '#0000FF',
  },
  control: {
    textAlign: 'left',
    padding: '20px',
  },
  textField: {
    maxWidth: 300,
    textAlign: 'center',
  },
  textField2: {
    maxWidth: 400,
    textAlign: 'center',
    border: 'none',
    height: "40px",
    fontSize: 15,
    lineheight: 2,
    boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'
  },
  textField3: {
    maxWidth: 400,
    textAlign: 'center',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    height: "40px",
    fontSize: 15,
    lineheight: 2,
  },
  textField4: {
    maxWidth: 500,
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    height: "40px",
    fontSize: 15,
    textAlign: 'center',
    lineheight: 2,
    color: '#0000FF',
  },
  textUnderLine: {
    fontWeight : "bold",
    borderBottom: "solid 1px",
},
  checkBox: {
    marginLeft: 35,
    padding: '20px 0 20px 0',
  },
  textCenter: {
    textAlign: 'center',
    padding: '20px'
  },
  textCenter2: {
    textAlign: 'center',
    padding: '20px 0px 20px 0px'
  },
  shadow:{
    boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'
  },
  box : {
    padding: '20px 12px 20px 12px',
    border: "1px solid rgba(224, 224, 224, 1)",
    backgroundColor: '#deebf7',
  },
  box2 : {
    padding: '20px -10px 20px 12px',
    border: "1px solid rgba(224, 224, 224, 1)",
    backgroundColor: '#deebf7',
  },
});

class Infoupd extends React.Component {
  state = {
    length: 0,
    getCount: 0,
    qrResult: '',
    isModalShow: false,
    isDataShow: false,
  }

  showMessage = () => {
    let param = {
      type:'close',
      title: '',
      message: 'dialog.click.btnGet',
      action: '',
    };
    this.props.doOpenDialogOperation(param);
    return;
  };
  
  // 登録者情報読取処理
  doSearch = async(KojinNum, Uuid) => {

    console.log("KojinNum", KojinNum);
    console.log("Uuid", Uuid);

    let check = "";
  
    //QRコードで読み込んだ個人番号をもとに世帯番号を取得
    let resKojin = await this.props.doGetKojin(KojinNum, Uuid, '', 'K');
    check = this.props.doCheckResponse(resKojin);
    if (!check) { return; }
    if (resKojin.data.totalCount == 0) { 
      document.getElementById("personalNumber").setAttribute('value', "");
      document.getElementById("name_0").setAttribute('value', "");
      this.props.change("status_0", "" );
      this.setState({
        isDataShow: false,
        length: 0
      });
      return; 
    }

    // QRコードで読み込んだ対象者を保存
    this.props.doSetRegisteredKojinInfoList(1, resKojin.data.records[0] );

    this.setState({getCount: resKojin.data.records.length});

    // 取得した個人情報を設定
    document.getElementById("personalNumber").setAttribute('value', resKojin.data.records[0].personalNumber.value);
    document.getElementById("name_0").setAttribute('value', resKojin.data.records[0].PersonalNameTextFiled.value);
    this.props.change("personalNumber_0", resKojin.data.records[0].personalNumber.value );
    this.props.change("householdNumber_0", resKojin.data.records[0].householdNumber.value );
    this.props.change("status_0", resKojin.data.records[0].status.value );
    this.props.change("representative_0", [] );
    if ( resKojin.data.records[0].RepresentativeCheckBox.value == "代表者" ) {
      this.props.change("representative_0", ["1"] );
    }

    // 取得した個人情報が代表者の場合
    if( resKojin.data.records[0].RepresentativeCheckBox.value == "代表者" ){

      //取得した世帯番号をもとに対象の住民を取得
      let resKojinList = await this.props.doGetKojin(resKojin.data.records[0].personalNumber.value, resKojin.data.records[0].UUIDTextFiled.value, resKojin.data.records[0].householdNumber.value, 'S');
      check = this.props.doCheckResponse(resKojinList);
      if (!check) { return; }
      if (resKojinList.data.totalCount == 0) { return; }

      //取得した件数をセット
      this.setState({length: resKojinList.data.records.length});

      if (resKojinList.data.records.length > 0  ) {
        this.setState({
          isDataShow: true,
        });
      }

      //各項目に取得した値を設定
      for(let i=0; i < resKojinList.data.records.length; i++){
        document.getElementById("personalNumber_" + (i+1)).setAttribute('value', resKojinList.data.records[i].personalNumber.value);
        document.getElementById("name_" + (i+1)).setAttribute('value', resKojinList.data.records[i].PersonalNameTextFiled.value);
        this.props.change("name_" + (i+1), resKojinList.data.records[i].PersonalNameTextFiled.value );
        this.props.change("householdNumber_" + (i+1), resKojinList.data.records[i].householdNumber.value );
        this.props.change("personalNumber_" + (i+1), resKojinList.data.records[i].personalNumber.value );
        this.props.change("representativeSave_" + (i+1), [] );
        if ( resKojinList.data.records[i].RepresentativeCheckBox.value == "代表者" ) {
          this.props.change("representative_" + (i+1), ["1"] );
        }
      }
    } else {
      this.setState({
        isDataShow: false,
        length: 0
      });
    }

  };

    //更新ボタン押下
  doSetKojin = async() => {

    if (this.state.getCount === 0 ){
      return;
    }

    console.log("this.state.length", this.state.length);
    console.log("this.props.values", this.props.values);

    let representativeCnt = 0;
    let errMessage = "";

    // // 更新対象者を再設定
    let values = this.props.kojinInfoInList[0];
    let record = {
      personalNumber : { value : values.personalNumber },
      UUIDTextFiled : { value : values.uuid },
      RepresentativeCheckBox : { value : values.representative },
      PersonalNameTextFiled : { value : values.personalName },
      status : { value : this.props.values.status_0 },
    };
    this.props.doSetRegisteredKojinInfoList(1, record);

    // 代表者チェック
    if ( this.props.values.representative_0[0] == "1" ){
      
      if ( this.state.length != 0 ) {
        for(let i=1; i < this.state.length + 1; i++){
          if ( "representative_" + i  in this.props.values ) { 
            if ( this.props.values["representative_" + i][0] == "1" ) {
              representativeCnt += 1;
            }
          }
        }

        // チェック判定
        if ( this.props.values.status_0 == "退所" && representativeCnt == 0 ){
          errMessage = 'dialog.error.representative';
        } else if ( this.props.values.status_0 == "退所" && representativeCnt != 1 ) {
          errMessage = 'dialog.error.representative';
        } else if ( this.props.values.status_0 != "退所" && representativeCnt > 1 ) {
          errMessage = 'dialog.error.representative';
        } else {
          console.log("OK");
          errMessage = "";
        }
  
        // エラーメッセージが設定された場合エラーとする
        if( errMessage != "" ){
          let param = {
            type:'close',
            title: '',
            message: errMessage,
            action: '',
          };
          this.props.openDialogOperation(param);
          return; 
        }
      }
    }

    //QRコードで読み込んだ個人番号をもとに更新
    let result = await this.props.doSetKojin( this.state.length );
    let check = this.props.doCheckResponse(result);
    if (!check) { return; }

    this.props.history.push('./updatecomplete');

  };

  getKojinNumber = () => {
    this.setState({
      isModalShow: true,
      qrResult: ''
    });
  }

  closeModal = () => {
    this.setState({
      isModalShow: false,
      onClickflg: '',
      qrResult: ''
    });
  }

  handleScan = (result, error) => {
    if (!!result) {
      console.log(result?.text);
      this.setState({
        qrResult: result?.text,
        isModalShow: false
      });

      let param = result?.text.split('___');
      console.log("param", param[0]);

      this.doSearch(param[0], param[1]);
    }
  }

  createRow = (idx) => {
    let classes = this.props.classes;
    let keys = {
      name: "name_"+idx,
      representative : "representative_"+idx,
      householdNumber : "householdNumber_" + idx,
      personalNumber : "personalNumber_" + idx
    };
    
    return (
      <Grid container className={classes.rows} key={idx}>
        <CssBaseline />
        <Grid container spacing={2}>
            <Grid item xs={7} className={classes.textCenter}>
              <span>
                <span>
                  <input
                    type="text"
                    name={keys.personalNumber}
                    id={keys.personalNumber}
                    className={classes.textField4}
                    disabled={true}
                  />
                </span>
                <span>
                  <input
                    type="text" 
                    name={keys.name} 
                    id={keys.name} 
                    className={classes.textField4} 
                    disabled={true}
                  />
                </span>
              </span>
            </Grid>
            <Grid item xs={5} className={classes.textCenter2}>
              <Field
                id={keys.representative}
                name={keys.representative}
                component={Render.checkBox}
                className={classes.checkBox}
                options={[
                  {key: "1"}
                ]}
                validate={[
                  (v) => Validator.required(v),
                ]}
              />
            </Grid>
            <Grid container component={Box} display={{ xs: "none" }} >
              <Field
                id={keys.householdNumber}
                name={keys.householdNumber}
                component={Render.textField}
                className={classes.textField}
              />
            </Grid>
          </Grid>
      </Grid>
    );
  }
  
  render() {
    const { classes } = this.props;
    
    let rows  = [];
    for(var i=1; i<=this.state.length; i++){
      rows.push(this.createRow(i));
    }
    
    return (
      <div className={classes.root}>
        <CssBaseline />
        <Grid container className={classes.container} spacing={2}>
          <Grid item xs={12}></Grid>
          <Grid item xs={12} sm={12} className={classes.explanation}>
            <span className={classes.fontBlue}>入所状態の変更</span><span>を行います</span>
          </Grid>
          <Grid item xs={12} sm={12} className={classes.text2} id="ShelterNameTextFiled">
              <span>避難所名：
                {this.props.shelterName}
              </span>
          </Grid>
          <Grid item xs={12} sm={12} >
            <span>以下の手順に従ってください</span>
          </Grid>
          <Grid item xs={12} sm={12} >
            <span className={classes.textUnderLine} >１.状態を変更したい方の個人用QRコードを読み取ってください</span>
          </Grid>
          <Grid item xs={12} sm={12} className={classes.explanation}>
            <Button
              id="btnGet"
              variant="contained"
              color="primary"
              onClick={this.getKojinNumber}
              className={classes.button}
              size="large"
            >  
              <span>QRコードの読取</span>
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} ></Grid>
            <Grid item xs={12} sm={12} >
              <span className={classes.textUnderLine} >２.現在の状態を変更してください</span>
            </Grid>
          <Grid item xs={12} >
          {/* className={classes.box} */}
            <Grid item xs={12}  className={classes.box2} container >
            <Grid item xs={5} className={classes.header}>
                  <FormattedMessage id={'infoupd.columns.name'}/>
          </Grid>
                <Grid item xs={7} className={classes.header}>
                  <FormattedMessage id={'infoupd.columns.status'}/>
          </Grid>

              <Grid item xs={7}>
                <span>
                  <span>
                    <input
                      type="text"
                      name="personalNumber"
                      id="personalNumber"
                      className={classes.textField4}
                      disabled={true}
                    />
                  </span>
                  <span>
                    <input
                      type="text" 
                      name="name_0" 
                      id="name_0"
                      className={classes.textField4} 
                      disabled={true}
                    />
                  </span>
                </span>
              </Grid>
              <Grid item xs={5}>
                <Field
                  id="status_0"
                  name="status_0"
                  component={Render.selectBox}
                  className={classes.text}
                  disabled={this.state.getCount > 0 ? false : true}
                  options={[
                    {key: "入所中", value: "入所中"},
                    {key: "退所", value: "退所"},
                    {key: "一時退所", value: "一時退所"},
                  ]}
                  validate={[
                    (v) => Validator.required(v),
                  ]}
                />
              </Grid>
              <Grid container component={Box} display={{ xs: "none" }} >
                <Field
                  id="personalNumber_0"
                  name="personalNumber_0"
                  component={Render.textField}
                  className={classes.textField}
                />
              </Grid>
              <Grid container component={Box} display={{ xs: "none" }} >
                <Field
                  id="householdNumber_0"
                  name="householdNumber_0"
                  component={Render.textField}
                  className={classes.textField}
                />
              </Grid>
            </Grid>
          </Grid>
          {
            this.state.isDataShow ? 
            <Grid item xs={12}>
              <Grid item xs={12} sm={12} className={classes.text3}>
                <span className={classes.textUnderLine}>代表者の方が退所する場合は、新たに代表者になる同世帯の方にチェックを入れてください</span>
              </Grid>
              <Grid item xs={12} sm={12}>
              </Grid>
              <Grid item xs={12} container className={classes.shadow}>
                {rows}
              </Grid>
            </Grid>
            : ""
          }
          <Grid item xs={12} sm={12} ></Grid>
          <Grid item xs={12} sm={12} >
            <span className={classes.textUnderLine} >３．登録してください</span>
          </Grid>
          <Grid item xs={12} sm={12} >
            <Button
              id="btnPost"
              variant="contained"
              color="primary"
              className={classes.button}
              size="large"
              onClick={this.doSetKojin}
              disabled={this.state.getCount > 0 ? false : true}
            >  
              <span>登録</span>
            </Button>
          </Grid>
          
          <Grid item xs={12} sm={12} >
          {
            this.state.isModalShow ? 
              <div id="modal" className={readQRcss["modal"] +" "+readQRcss["is-show"]}> 
                  <Button
                    id="modalClose"
                    variant="contained"
                    color="primary"
                    onClick={this.closeModal}
                    className={classes.button + " " + readQRcss["modal-close"]}
                    size="large">閉じる</Button>
                  <div id="modalInner" className={readQRcss["modal-inner"]} ref="modalInner">
                    <QrReader
                      scanDelay={300}
                      onResult={this.handleScan}
                      videoContainerStyle={{ position: "absolute", "paddingTop": '0%', width: '100%', height: '100%' }}
                      constraints={ {facingMode: {exact: 'environment'} }}
                    />
                  </div>
                  <div id="modalBackground" className={readQRcss["modal-background"] +" "+readQRcss["is-show"]} ></div>
              </div>
              
             : ""
          }
          </Grid>
        </Grid>
      </div>
    );
  }
}

const FORM_NAME = "Infoupd";

const mapStateToProps = state => ({
  initialValues:{
  },
  values: getFormValues(FORM_NAME)(state),
  shelterName: state.infoupd.shelterName,
  kojinInfoInList: state.infoupd.kojinInfo,
});

const mapDispatchToProps = {
};

Infoupd = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect(state => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Infoupd));

Infoupd.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Infoupd));